module.exports = __webpack_public_path__ + "img/team8.6e53a41f.jpg";